import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ModalService } from '@app/core/services/modal.service';
import { SrOperationResourceGet, SrOperationService } from '@app/services/sr-operation.service';

@Component({
    selector: 'tt-sr-operation-resource',
    templateUrl: './sr-operation-resource.component.html',
    styleUrls: ['./sr-operation-resource.component.css'],
    standalone: false,
})
export class SrOperationResourceComponent implements OnInit {
    public page?: SrOperationResourceGet;
    public deleting = false;

    constructor(
        private readonly operation: SrOperationService,
        private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        this.page = await this.operation.getResource({
            special_hrs_custactresource_keyno: String(this.navigator?.params['special_hrs_custactresource_keyno'] ?? ''),
        });
    }

    public async deleteValues(): Promise<void> {
        if (!this.page || this.deleting) return;
        this.deleting = true;
        try {
            const response = await this.operation.deleteResource(this.page);
            if (response.errorcode !== '0') await this.showWarning(response.errormessage);
            else await this.navigator?.back();
        } finally { this.deleting = false; }
    }

    private showWarning(message: string): Promise<void> {
        return this.modal.show({ type: 'warning', title: 'Varsel', message, buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
    }
}
